module.exports = __webpack_public_path__ + "img/slide3.aa21ea82.svg";